import React from "react";
import { Route, Routes } from "react-router-dom";
import { pagesRoute, posRoutes, publicRoutes } from "./router.link";
import PrivateRoute from "./PrivateRoute";
import { HeaderLayout, AuthLayout, PosLayout } from "./layouts";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/pos" element={<PosLayout />}>
        {posRoutes.map((route, id) => (
          <Route path={route.path} element={route.element} key={id} />
        ))}
      </Route>

      <Route
        path="/"
        element={
          <PrivateRoute>
            <HeaderLayout />
          </PrivateRoute>
        }
      >
        {publicRoutes.map((route, id) => (
          <Route path={route.path} element={route.element} key={id} />
        ))}
      </Route>

      <Route path="/" element={<AuthLayout />}>
        {pagesRoute.map((route, id) => (
          <Route path={route.path} element={route.element} key={id} />
        ))}
      </Route>
    </Routes>
  );
};

export default AllRoutes;
